import { render, staticRenderFns } from "./Ssv2308ExcecRadarCotacNew.vue?vue&type=template&id=b9d58620&"
import script from "./Ssv2308ExcecRadarCotacNew.vue?vue&type=script&lang=js&"
export * from "./Ssv2308ExcecRadarCotacNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports